import { FC } from 'react'

import { AvatarProps } from './AvatarProps'

import { Abbr, Box } from './styles'

export const Avatar: FC<AvatarProps> = (props) => {
  const { username } = props

  const abbr =
    (username || '')
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part.charAt(0))
      .join('')
      .toUpperCase() || '#'

  return (
    <Box>
      <Abbr>{abbr}</Abbr>
    </Box>
  )
}
